<hazmatsuite-next-stepper
  [async]="false"
  [steps]="(stepperItems$ | async) || []"
  (selectStep)="selectStep($event)"
></hazmatsuite-next-stepper>

<ng-container *ngrxLet="hasPackages$ as hasPackages"></ng-container>
<ng-container *ngIf="packingListResource$ | async as packingListResource">
  <div id="ch-ggs-web-suite-content">
    <div class="container">
      <h1>{{ packingListResource['HeadingTitlePackages'] }}</h1>
      <div class="row">
        <div class="col-md-3">
          <h3>{{ packingListResource['HeadingTitlePackages'] }}</h3>
          <div class="ch-ggs-web-suite-dropdown" id="actions">
            <a
              [routerLink]=""
              *ngIf="data?.TransportMode === transportModes.Sea"
              class="btn btn-block btn-iconed btn-iconed-primary btn-iconed-left"
              (click)="
                addPackaging(
                  packageTypes.CompositePacking_EQ,
                  packingListResource['AddCombinationPackagingEQ']
                )
              "
            >
              {{ packingListResource['AddCombinationPackagingEQ']
              }}<span class="btn-icon ifc ifc-tanks" aria-hidden="true"
                ><span class="path1"></span><span class="path2"></span
                ><span class="path3"></span><span class="path4"></span
              ></span>
            </a>
            <a
              [routerLink]=""
              *ngIf="
                data?.TransportMode === transportModes.Sea ||
                data?.TransportMode === transportModes.Air
              "
              class="btn btn-block btn-iconed btn-iconed-primary btn-iconed-left"
              (click)="
                addPackaging(
                  packageTypes.CompositePacking_LQ,
                  packingListResource['AddCombinationPackagingLQ']
                )
              "
            >
              {{ packingListResource['AddCombinationPackagingLQ']
              }}<span class="btn-icon ifc ifc-tanks" aria-hidden="true"
                ><span class="path1"></span><span class="path2"></span
                ><span class="path3"></span><span class="path4"></span
              ></span>
            </a>
            <a
              [routerLink]=""
              class="btn btn-block btn-iconed btn-iconed-primary btn-iconed-left"
              (click)="
                addPackaging(
                  packageTypes.SinglePacking,
                  packingListResource['AddSinglePackaging']
                )
              "
            >
              {{ packingListResource['AddSinglePackaging']
              }}<span class="btn-icon ifc ifc-barrel" aria-hidden="true"
                ><span class="path1"></span><span class="path2"></span
                ><span class="path3"></span><span class="path4"></span
              ></span>
            </a>
            <a
              [routerLink]=""
              class="btn btn-block btn-iconed btn-iconed-primary btn-iconed-left"
              (click)="
                addPackaging(
                  packageTypes.CompositePacking,
                  packingListResource['AddCombinationPackaging']
                )
              "
            >
              {{ packingListResource['AddCombinationPackaging']
              }}<span class="btn-icon ifc ifc-tanks" aria-hidden="true"
                ><span class="path1"></span><span class="path2"></span
                ><span class="path3"></span><span class="path4"></span
              ></span>
            </a>
            <a
              [routerLink]=""
              *ngIf="data?.TransportMode !== transportModes.Air"
              class="btn btn-block btn-iconed btn-iconed-primary btn-iconed-left"
              (click)="
                addPackaging(packageTypes.Tank, packingListResource['AddTank'])
              "
            >
              {{ packingListResource['AddTank']
              }}<span
                class="btn-icon ifc-custom ifc-tank"
                aria-hidden="true"
              ></span>
            </a>
            <a
              [routerLink]=""
              *ngIf="data?.TransportMode !== transportModes.Air"
              class="btn btn-block btn-iconed btn-iconed-primary btn-iconed-left"
              (click)="
                addPackaging(packageTypes.Bulk, packingListResource['AddBulk'])
              "
            >
              {{ packingListResource['AddBulk']
              }}<span
                class="btn-icon ifc-custom ifc-bulk"
                aria-hidden="true"
              ></span>
            </a>
          </div>
        </div>
        <div class="col-md-9" id="packingListData">
          <easydgd-packing-list-treeview
            (openEditor)="openEditor($event.packageType, $event.title)"
          ></easydgd-packing-list-treeview>
        </div>
        <form [formGroup]="formGroup" class="col-12">
          <input type="hidden" formControlName="items" />
          <easydgd-footer-navigation-buttons></easydgd-footer-navigation-buttons>
        </form>
      </div>
    </div>
  </div>

  <hazmatsuite-next-modal
    [title]="packageEditorTitle"
    [showModal]="packageEditorOpen"
    [confirmButtonLabel]="
      (activeEditorType !== packageTypes.SinglePacking &&
        this.activeEditorType !== packageTypes.Bulk &&
        this.activeEditorType !== packageTypes.Tank) ||
      (showConfirmButtonLabel$ | async)
        ? packingListResource['ButtonApply']
        : null
    "
    modalSize="xl"
    (closeModal)="closePackageEditorModal()"
    (confirm)="packagingIsValid ? savePackage() : markChildAsTouched()"
  >
    <container-element [ngSwitch]="activeEditorType">
      <div class="col-12">
        <ng-container
          *ngIf="
            activeEditorType === packageTypes.SinglePacking ||
            activeEditorType === packageTypes.Tank ||
            activeEditorType === packageTypes.Bulk
          "
        >
          <easydgd-single-packaging-item-editor
            #singlePackaging
            [transportMode]="data.TransportMode || transportModes.Unknown"
            (valid)="packagingIsValid = $event"
            (packageChanged)="updatePackage($event)"
          ></easydgd-single-packaging-item-editor>
        </ng-container>
        <ng-container
          *ngIf="
            activeEditorType === packageTypes.CompositePacking ||
            activeEditorType === packageTypes.CompositePacking_EQ ||
            activeEditorType === packageTypes.CompositePacking_LQ
          "
        >
          <easydgd-composite-packaging-item-editor
            #compositePackaging
            [transportMode]="data.TransportMode || transportModes.Unknown"
            (valid)="packagingIsValid = $event"
            (packageChanged)="updatePackage($event)"
          ></easydgd-composite-packaging-item-editor>
        </ng-container>
      </div>
    </container-element>
  </hazmatsuite-next-modal>
</ng-container>
